export const MyCompanyPaths = {
  UserManagement: {
    users: '/user-management/users',
    roles: '/user-management/roles'
  },
  CompanyProfile: {
    ViewProfile: '/viewprofile/:companyId',
    ViewProfileV2: '/view-profile/:companyId',
    EditCompanyProfile: '/edit-company-profile',
    EditCompanyProfileSections: {
      CompanyInfo: '/edit-company-profile',
      Contacts: '/edit-company-profile/contact-details',
      Compliance: '/edit-company-profile/compliance',
      Documents: '/edit-company-profile/documents',
      TradeReferences: '/edit-company-profile/trade-references',
      ShareHolderDetails: '/edit-company-profile/shareholder-details'
    }
  }
};
